import { MODAL_COLLABORATORS_PURCHASE_FILTER_HIDE, MODAL_COLLABORATORS_PURCHASE_FILTER_SHOW } from "../contants";

const INIT_STATE = {
    showCollaboratorsPurchaseFilterModal: false,
};

const ModalReducer = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case MODAL_COLLABORATORS_PURCHASE_FILTER_SHOW:
          return { 
            ...state, 
            showCollaboratorsPurchaseFilterModal: true, 
          };
        case MODAL_COLLABORATORS_PURCHASE_FILTER_HIDE:
          return {
            ...state,
            showCollaboratorsPurchaseFilterModal: false,
          };
        default:
            return { ...state };
    }
};

export default ModalReducer;
